(function () {
  'use strict';

  class WishlistComponent extends HTMLElement {
    static get observedAttributes() {
      return ['product'];
    }

    constructor() {
      super();
      this._product = null;
    }

    connectedCallback() {
      if (!this._product && this.hasAttribute('product')) {
        this._product = this.parseProduct(this.getAttribute('product'));
      }

      this.render();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name !== 'product' || oldValue === newValue) return;

      this._product = this.parseProduct(newValue);
      this.render();
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      this.render();
    }

    parseProduct(value) {
      if (!value) return null;
      if (typeof value === 'object') return value;

      try {
        return JSON.parse(value);
      } catch (error) {
        return null;
      }
    }

    getVariantId(product) {
      const variant = product?.selected_variant || product?.selectedVariant || product?.variants?.[0] || null;
      const id = product?.variantId || product?.variant_id || variant?.id || variant?.variantId || variant?.variant_id;

      return id == null ? '' : String(id).replace('gid://shopify/ProductVariant/', '');
    }

    escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    render() {
      const variantId = this.getVariantId(this.product);

      this.innerHTML = variantId
        ? `<wishlist-button class="fish-wishlist-plp-btn" data-variant-id="${this.escapeHtml(variantId)}"></wishlist-button>`
        : '';
    }
  }

  if (!customElements.get('rcc-wishlist')) {
    customElements.define('rcc-wishlist', WishlistComponent);
  }
})();
